import { useCurrentUserContext } from '@shared/hooks/useCurrentUserContext';

const useIsGetStartedAvailable = () => {
  const { user: currentUser } = useCurrentUserContext();

  return !currentUser?.shownGetStarted;
};

export default useIsGetStartedAvailable;
